import React from "react";
import "./Hero.scss";

import Typed from "typed.js";

// import RegistrationForm from "components/RegistrationForm";
import Button from "components/Button";

import ProjectCard from "components/ProjectCard";

import * as ROUTES from "constants/routes";

const creativeOptions = {
  string: [
    "Boardpholio is for <span>Designers</span>",
    "Boardpholio is for <span>Developers</span>"
  ],
  typeSpeed: 30,
  stringsElement: "#creative-strings",
  showCursor: false,
  loop: true,
  smartBackspace: true,
  shuffle: true
};

const Thumbs = ({ projects }) => {
  return (
    <div className="ThumbnailContainer">
      {projects.map((project, i) => {
        if (project.images[0]) {
          return project.images[0].image && i < 3 ? (
            // <Thumbnail image={project.images[0].image} i={i} height={297} />
            <ProjectCard compact {...project} />
          ) : null;
        }

        return false;
      })}
    </div>
  );
};

class Hero extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      view: "creative",
      loaded: false
    };
  }
  componentDidMount() {
    new Typed("#typed", creativeOptions);
    setTimeout(() => {
      this.setState({ loaded: true });
    }, 500);
  }
  render() {
    return (
      <div className="Hero" data-loaded={this.state.loaded}>
        <div className="hero-content">
          <div className="creative wrap">
            <div id="creative-strings">
              <span>
                Boardpholio is for <span>Print Designers</span>
              </span>
              <span>
                Boardpholio is for <span>Illustrators</span>
              </span>
              <span>
                Boardpholio is for <span>Developers</span>
              </span>
              <span>
                Boardpholio is for <span>Photographers</span>
              </span>
              <span>
                Boardpholio is for <span>Directors</span>
              </span>
              <span>
                Boardpholio is for <span>Animators</span>
              </span>
              <span>
                Boardpholio is for <span>3D Artists</span>
              </span>
              <span>
                Boardpholio is for <span>Typographers</span>
              </span>
              <span>
                Boardpholio is for <span>UX Professionals</span>
              </span>
              <span>
                Boardpholio is for <span>Architects</span>
              </span>
              <span>
                Boardpholio is for <span>Product Designers</span>
              </span>
            </div>
            <div className="typing">
              <h1 id="typed">&nbsp;</h1>
            </div>
            <p>
              Boardpholio helps you present a visual work history. Powerful for
              you, powerful for hiring decision makers.
            </p>

            {this.props.user ? null : (
              <Button to={ROUTES.SIGN_UP} type="orange">
                Get started: your first project
              </Button>
            )}
          </div>
        </div>
        <Thumbs projects={this.props.projects} />
      </div>
    );
  }
}

// const Hero = ({ isLoggedIn }) => (

//   //   style={{
//   //     backgroundImage:
//   //       "url(https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/dae53275565101.5c506e9e8a009.gif)"
//   //   }}
//   // >
//   //   <div className="overlay" />
//   //   <div className="hero-content">
//   //     <div className="copy">
//   //       <h1>The resume is dead.</h1>
//   //       <h4>BoardPholio helps creatives thrive among professionals.</h4>
//   //       <p>
//   //         BoardPholio is the new universal platform that displays and tags all
//   //         the information and visuals anyone would need to make a hiring
//   //         decision.
//   //       </p>
//   //     </div>
//   //     <div className="form">
//   //       {isLoggedIn ? null : <RegistrationForm onlyForm />}
//   //     </div>
//   //   </div>
// );

export default Hero;
